import Vue from "vue";
import Router from "vue-router";

import LoginPage from "@/views/Auth/Login";
import DashboardMain from "@/views/Dashboard/Main";

//Edit Profile
import EditProfile from "@/views/Auth/EditProfile";

//Error Pages
import NotFound from "@/views/Error/SmallNotFound";
import PageNotFound from "@/views/Error/PageNotFound";

//Highlight
const HighlightMain = () => import("@/views/Dashboard/Highlight/Main");
import Highlight from "@/views/Dashboard/Highlight/Highlight";
import HighlightLabelMaker from "@/views/Dashboard/Highlight/HighlightLabelMaker";
import HighlightOilMaker from "@/views/Dashboard/Highlight/HighlightOilMaker";
import HighlightCustomer from "@/views/Dashboard/Highlight/HighlightCustomer";

//CustomerActivities
const CustomerActivitiesMain = () => import("@/views/Dashboard/CustomerActivities/Main");
import CustomerActivities from "@/views/Dashboard/CustomerActivities/CustomerActivities";

//Data Submission
const DataSubmissionMain = () => import("@/views/Dashboard/DataSubmission/Main");
// const DataSubmissionLabelMaker = () => import("@/views/Dashboard/DataSubmission/DataSubmissionLabelMaker");
const DataSubmissionOilMaker = () => import("@/views/Dashboard/DataSubmission/DataSubmissionOilMaker");
const RecipientContacts = () => import("@/views/Dashboard/DataSubmission/RecipientContacts");
const ReminderSettings = () => import("@/views/Dashboard/DataSubmission/ReminderSettings");

//Consumer Insights
const ConsumerInsightsMain = () => import("@/views/Dashboard/ConsumerInsights/Main");
import ConsumerInsights from "@/views/Dashboard/ConsumerInsights/ConsumerInsights";

//Reports
const ReportsMain = () => import("@/views/Dashboard/Reports/Main");
const ReportCustomer = () => import("@/views/Dashboard/Reports/ReportCustomer2");
const ReportLabelMaker = () => import("@/views/Dashboard/Reports/ReportLabelMaker");
const ReportOilMaker = () => import("@/views/Dashboard/Reports/ReportOilMaker");
const ReportQrCode = () => import("@/views/Dashboard/Reports/ReportQrCode");
const ReportSuspect = () => import("@/views/Dashboard/Reports/ReportSuspect");
const SummaryReport = () => import("@/views/Dashboard/Reports/SummaryReport");
const DownloadReport = () => import("@/views/Dashboard/Reports/DownloadReport");

//Domain Detection
const DomainDetectionMain = () => import("@/views/Dashboard/DomainDetection/Main");
const DomainDetectionSummary = () => import("@/views/Dashboard/DomainDetection/DomainDetectionSummary");
const ReviewDomain = () => import("@/views/Dashboard/DomainDetection/ReviewDomain");
const ReviewDomainDetail = () => import("@/views/Dashboard/DomainDetection/ReviewDomainDetail");
const DomainDistribution = () => import("@/views/Dashboard/DomainDetection/DomainDistribution");

//Settings
const SettingsMain = () => import("@/views/Dashboard/Settings/Main");
import LogHistoryActivity from "@/views/Dashboard/Settings/UserManagement/LogDashboardActivity";
//User Management
const UserManagementMain = () => import("@/views/Dashboard/Settings/UserManagement/Main");
import DashboardUserUM from "@/views/Dashboard/Settings/UserManagement/DashboardUserUM";
import OilMakerAppUM from "@/views/Dashboard/Settings/UserManagement/OilMakerAppUM";
import PenindakanAppUM from "@/views/Dashboard/Settings/UserManagement/PenindakanAppUM";
import CrossClient from "@/views/Auth/CrossClient";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    //Login Path
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "Login",
      component: LoginPage,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/cross-client",
      name: "Cross Client",
      component: CrossClient,
      meta: {
        requiresAuth: false,
      },
    },

    //Edit Profile
    {
      path: "",
      component: DashboardMain,
      children: [
        {
          path: "/edit-profile",
          name: "EditProfile",
          component: EditProfile,
          meta: {
            requiresAuth: true,
            sidebar: true,
          },
        },
      ],
    },

    //Dashboard Start
    {
      path: "/dashboard",
      name: "Dashboard",
      component: DashboardMain,
      children: [
        //Default Fallback
        {
          path: "",
          name: "Dashboard",
          component: NotFound,
        },

        //Highlight
        {
          path: "highlight",
          component: HighlightMain,
          children: [
            {
              path: "",
              name: "Highlight",
              component: Highlight,
            },
            {
              path: "label-maker",
              name: "HighlightLabelMaker",
              component: HighlightLabelMaker,
              meta: {
                menu: "Highlight",
                module: "Label Maker",
              },
            },
            {
              path: "oil-maker",
              name: "HighlightOilMaker",
              component: HighlightOilMaker,
              meta: {
                menu: "Highlight",
                module: "Oil Maker",
              },
            },
            {
              path: "customer",
              name: "HighlightCustomer",
              component: HighlightCustomer,
              meta: {
                menu: "Highlight",
                module: "Customer",
              },
            },
          ],
        },

        //Activities
        {
          path: "customer-activities",
          component: CustomerActivitiesMain,
          children: [
            {
              path: "",
              name: "CustomerActivities",
              component: CustomerActivities,
              meta: {
                menu: "Customer Activities",
                module: "Customer Activities",
              },
            },
          ],
        },


        //Data Submission
        {
          path: "data-submission",
          component: DataSubmissionMain,
          children: [
            {
              path: "",
              name: "DataSubmission",
              component: NotFound,
            },
            // {
            //   path: "label-maker",
            //   name: "DataSubmissionLabelMaker",
            //   component: DataSubmissionLabelMaker,
            //   meta: {
            //     menu: "Data Submission",
            //     module: "Label Maker",
            //   },
            // },
            {
              path: "oil-maker",
              name: "DataSubmissionOilMaker",
              component: DataSubmissionOilMaker,
              meta: {
                menu: "Data Submission",
                module: "Oil Maker",
              },
            },
            {
              path: "recipient-contacts",
              name: "RecipientContacts",
              component: RecipientContacts,
              meta: {
                menu: "Data Submission",
                module: "Recipient Contacts",
              },
            },
            {
              path: "reminder-settings",
              name: "ReminderSettings",
              component: ReminderSettings,
              meta: {
                menu: "Data Submission",
                module: "Reminder Settings",
              },
            },
          ],
        },
        //Consumer Insights
        {
          path: "consumer-insights",
          component: ConsumerInsightsMain,
          children: [
            {
              path: "",
              name: "ConsumerInsights",
              component: ConsumerInsights,
            },
          ],
        },

        //Reports
        {
          path: "reports",
          component: ReportsMain,
          children: [
            {
              path: "",
              name: "Reports",
              component: NotFound,
            },
            {
              path: "customer",
              name: "ReportCustomer",
              component: ReportCustomer,
              meta: {
                menu: "Reports",
                module: "Report Customer",
              },
            },
            {
              path: "label-maker",
              name: "ReportLabelMaker",
              component: ReportLabelMaker,
              meta: {
                menu: "Reports",
                module: "Report Label Maker",
              },
            },
            {
              path: "oil-maker",
              name: "ReportOilMaker",
              component: ReportOilMaker,
              meta: {
                menu: "Reports",
                module: "Report Oil Maker",
              },
            },
            {
              path: "qrcode",
              name: "ReportQrCode",
              component: ReportQrCode,
              meta: {
                menu: "Reports",
                module: "Report Suspect",
              },
            },
            {
              path: "suspect",
              name: "ReportSuspect",
              component: ReportSuspect,
              meta: {
                menu: "Reports",
                module: "QR Code",
              },
            },
            {
              path: "summary-report",
              name: "SummaryReport",
              component: SummaryReport,
              meta: {
                menu: "Reports",
                module: "Summary Report",
              },
            },
            // {
            //   path: "not-found-report",
            //   name: "ReportNotFound",
            //   component: ReportNotFound,
            //   meta: {
            //     menu: "Reports",
            //     module: "Not Found Report",
            //   },
            // },
          ],
        },

        //Summary Report
        // {
        //   path : 'summary-report',
        //   component : SummaryReportMain,
        //   children : [{
        //     path : '',
        //     name : 'SummaryReport',
        //     component : SummaryReport
        //   },{
        //     path : 'summary-report',
        //     name : 'SummaryReport',
        //     component : SummaryReport,
        //     meta : {
        //       menu : 'SummaryReport',
        //       module : 'Summery Report'
        //     }
        //   }]
        // },

        //Domain Detection
        {
          path: "domain-detection",
          component: DomainDetectionMain,
          children: [
            {
              path: "",
              name: "DomainDetection",
              component: NotFound,
            },
            {
              path: "summary",
              name: "DomainDetectionSummary",
              component: DomainDetectionSummary,
              meta: {
                menu: "Domain Detection",
                module: "Summary",
              },
            },
            {
              path: "review-domain",
              name: "ReviewDomain",
              component: ReviewDomain,
              meta: {
                menu: "Domain Detection",
                module: "Review Domain",
              },
            },
            {
              path: "review-domain/:domain_id",
              name: "ReviewDomainDetail",
              component: ReviewDomainDetail,
              meta: {
                menu: "Domain Detection",
                module: "Review Domain Detail",
              },
            },
            {
              path: "domain-distribution",
              name: "DomainDistribution",
              component: DomainDistribution,
              meta: {
                menu: "Domain Detection",
                module: "Domain Distribution",
              },
            },
          ],
        },

        //Settings
        {
          path: "settings",
          component: SettingsMain,
          children: [
            {
              path: "",
              name: "Settings",
              component: NotFound,
            },
            {
              path: "log-history-activity",
              name: "LogHistoryActivity",
              component: LogHistoryActivity,
              meta: {
                menu: "Settings",
                module: "Log Dashboard Activity",
              },
            },
            {
              path: "user-management",
              component: UserManagementMain,
              children: [
                {
                  path: "dashboard-user",
                  name: "DashboardUserManagement",
                  component: DashboardUserUM,
                  meta: {
                    menu: "Settings - User Management",
                    module: "Dashboard User",
                  },
                },
                {
                  path: "oil-maker-app",
                  name: "OilMakerAppUserManagement",
                  component: OilMakerAppUM,
                  meta: {
                    menu: "Settings - User Management",
                    module: "Oil Maker App",
                  },
                },
                {
                  path: "penindakan-app",
                  name: "PenindakanAppUserManagement",
                  component: PenindakanAppUM,
                  meta: {
                    menu: "Settings - User Management",
                    module: "Penindakan App",
                  },
                },
              ],
            },
          ],
        },
        {
          path: "internal-data-export",
          name: "InternalDataExport",
          component: DownloadReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "data-export",
          redirect: "/dashboard/internal-data-export",
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },

    //Error 404 Page Not Found
    {
      path: "*",
      component: PageNotFound,
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

export default router;
